<div class="w-full">
  <!-- Search Bar & Werk Filter -->
  <div class="glass-card p-4 rounded-2xl mb-6 relative z-100">
    <div class="flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div class="relative flex-1 max-w-md">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <span class="material-icons text-xl text-text-muted">search</span>
        </div>
        <input
          type="text"
          [formControl]="searchControl"
          placeholder="Suche nach Auftrags-Nr., Kunde..."
          class="search-input w-full pl-12 pr-10 py-3 rounded-xl bg-white/8 border border-white/12 text-text-primary placeholder-text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
        />
        @if (searchControl.value) {
          <button
            type="button"
            class="absolute inset-y-0 right-0 pr-4 flex items-center text-text-muted hover:text-text-primary transition-colors"
            (click)="clearSearch()"
          >
            <span class="material-icons text-xl">close</span>
          </button>
        }
      </div>

      <!-- Werk Filter -->
      <div class="flex items-center gap-2">
        <span class="material-icons text-text-muted">filter_list</span>
        <p-multiSelect
          [formControl]="werkFilterControl"
          [options]="werkOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Werk filtern"
          [filter]="false"
          [showClear]="true"
          [display]="'chip'"
          [maxSelectedLabels]="3"
          styleClass="multiselect-component-style"
          panelStyleClass="multiselect-component-panel-style"
        >
          <ng-template pTemplate="item" let-option>
            <div class="option-row">
              <span class="option-label">{{ option.label }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
  </div>

  <!-- Table card -->
  <div class="glass-card rounded-2xl overflow-hidden">
    <div class="overflow-x-auto">
      <app-delivery-date-table
        [rows]="rows()"
        [loading]="loading()"
        [error]="error()"
        [sort]="sort()"
        [clickable]="true"
        emptyMessage="Keine anstehenden Liefertermine gefunden."
        (sortChange)="onSortChange($event)"
        (rowClick)="openOrderDocument($event)"
      ></app-delivery-date-table>
    </div>

    <!-- Pagination -->
    @if (totalItems() > 0) {
      <div class="px-6 py-4 border-t border-white/10">
        <app-pagination
          [currentPage]="currentPage()"
          [totalPages]="totalPages()"
          [totalItems]="totalItems()"
          [pageSize]="pageSize"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    }
  </div>
</div>
